<script>
import Dropdown from "../Dropdown.vue";
import {mapStores, mapWritableState} from "pinia";
import {TherapiesStore} from "../../stores/TherapiesStore";
import {FormDataStore} from "../../stores/FormDataStore";

export default {
  name: "TherapyRequiredQuestion",
  components: {Dropdown},
  computed: {
    ...mapStores(TherapiesStore, FormDataStore),
    ...mapWritableState(FormDataStore, ["formData"]),
  },
  data: function () {
    return {
      therapies: [],
      selecting: false,
    };
  },
  methods: {
    getTherapies() {
      this.therapies = this.therapiesStore.getTherapies();
    },
    setTherapy(therapy) {
      this.formData.therapyRequired.therapy = therapy;

      if (this.formData.therapyRequired.therapy.name !== 'Other') {
        this.formData.therapyRequired.therapyOtherDetails = '';
      }

      this.selecting = false;
    },
  },
  mounted() {
    this.formData.therapyRequired.therapy = null;
    this.formData.therapyRequired.therapyOtherDetails = '';
    this.getTherapies();
  }
}
</script>

<template>
  <div id="therapyRequiredQuestion">
    <h2>Therapy Required</h2>
    <div class="mb-4" v-if="therapies.length > 0">
      <Dropdown @opened="selecting = true;" :value="formData.therapyRequired.therapy" :options="therapies" @change="setTherapy" />
    </div>
    <div class="details-form-row" v-if="!selecting && formData.therapyRequired.therapy !== null && formData.therapyRequired.therapy.name === 'Other'">
      <label>Please enter the details of the therapy you require</label>
      <textarea v-model="formData.therapyRequired.therapyOtherDetails"></textarea>
    </div>
  </div>
</template>

<style scoped>

</style>